import pluriLogo from "./../../image/logo.png";

function Error404Header() {
  return (
    <header>
      <nav className="navbar navbar-light bg-light">
        <div className="navbar-brand">
          <img
            src={pluriLogo}
            width="60"
            height="60"
            className="d-inline-block align-top"
            alt=""
          />
          <label className="py-3">Pluritongues LAMS </label>
        </div>
      </nav>
    </header>
  );
}

export default Error404Header;
